import BaseApi from './baseApi';
import ITransformationsPalletsSource from '../models/ITransformationsPalletsSource';
import IAuthentication from '../models/IAuthentication';
import { identityTransform } from 'ol/proj';
export default class TransformationPalletsSourceApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Transformations");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetTransformationsPalletsSource(idTransformation: string) : Promise<ITransformationsPalletsSource[]> {
        let json = this.getJsonReadWithIdTransformation(idTransformation);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var transformationsPalletsSource: ITransformationsPalletsSource[] = [];
            transformationsPalletsSource = response.data as ITransformationsPalletsSource[];
            return transformationsPalletsSource;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetTransformationsPalletsSourceByPalletsDestination(idTransformationPalletsDestination: string) : Promise<ITransformationsPalletsSource[]> {
        let json = this.getJsonReadWithIdTransformationPalletsDestination(idTransformationPalletsDestination);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var transformationsPalletsSource: ITransformationsPalletsSource[] = [];
            transformationsPalletsSource = response.data as ITransformationsPalletsSource[];
            return transformationsPalletsSource;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveTransformationPalletsSource(transformationPalletSource: ITransformationsPalletsSource) : Promise<string> {
        const json = this.getJsonSave(transformationPalletSource);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateTransformationPalletsSource(transformationPalletSource: ITransformationsPalletsSource) : Promise<boolean> {
        const json = this.getJsonUpdate(transformationPalletSource);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteTransformationPalletSource(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteTransformationPalletSourceByTransformationIdAndGoodId(transformationId: string, idGood: string, goodsPerCase: number) {
        const json = this.getJsonDeleteByTransformationIdAndGoodId(transformationId, idGood, goodsPerCase);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteTransformationPalletSourceByTransformationId(transformationId: string) {
        const json = this.getJsonDeleteByTransformationId(transformationId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByTransformationId(idTransformation: string) {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "idTransformation",
                "Item3": "=",
                "Item4": idTransformation
            }],
            "table": "transformationsPalletsSource"
        };
        return json;
    }

    private getJsonDeleteByTransformationIdAndGoodId(idTransformation: string, idGood: string, goodsPerCase: number) {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "idTransformation",
                "Item3": "=",
                "Item4": idTransformation,
                "Item5": "AND"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idGood",
                "Item3": "=",
                "Item4": idGood,
                "Item5": "AND"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "goodsPerCase",
                "Item3": "=",
                "Item4": goodsPerCase
            }],
            "table": "transformationsPalletsSource"
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "transformationsPalletsSource"
        };
        return json;
    }

    private getJsonSave(transformationPalletSource: ITransformationsPalletsSource) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idGood",
                "Item2": transformationPalletSource.idGood
            }, {
                "Item1": "idPallet",
                "Item2": transformationPalletSource.idPallet
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": transformationPalletSource.idInboundDeliveryNoteDetail
            }, {
                "Item1": "idListPallet",
                "Item2": transformationPalletSource.idListPallet
            }, {
                "Item1": "totalCases",
                "Item2": transformationPalletSource.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": transformationPalletSource.goodsPerCase
            }, {
                "Item1": "idTransformation",
                "Item2": transformationPalletSource.idTransformation
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "transformationsPalletsSource"
        };
        return json;
    }

    private getJsonUpdate(transformationPalletSource: ITransformationsPalletsSource) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idGood",
                "Item2": transformationPalletSource.idGood
            }, {
                "Item1": "idPallet",
                "Item2": transformationPalletSource.idPallet
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": transformationPalletSource.idInboundDeliveryNoteDetail
            }, {
                "Item1": "idListPallet",
                "Item2": transformationPalletSource.idListPallet
            }, {
                "Item1": "totalCases",
                "Item2": transformationPalletSource.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": transformationPalletSource.goodsPerCase
            }, {
                "Item1": "idTransformation",
                "Item2": transformationPalletSource.idTransformation
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "transformationsPalletsSource",
            "keyvalue": transformationPalletSource.id
        };
        return json;
    }

    private getJsonReadWithIdTransformation(idTransformation: string) : any {
        const json = {
            "fields": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "id"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idPallet"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idInboundDeliveryNoteDetail"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as palletType"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "totalCases"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idTransformation"
            }],
            "tables": [{
                "Item1": "transformationsPalletsSource"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Goods"
            }],
            "conditions": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idTransformation",
                "Item3": "=",
                "Item4": idTransformation
            }],
            "joins": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }]
        };
        return json;
    }

    private getJsonReadWithIdTransformationPalletsDestination(idTransformationPalletsDestination: string) : any {
        const json = {
            "fields": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "id"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idPallet"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idInboundDeliveryNoteDetail"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as palletType"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "totalCases"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idTransformation"
            }],
            "tables": [{
                "Item1": "transformationsPalletsSource"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Goods"
            }],
            "conditions": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idTransformationPalletsDestination",
                "Item3": "=",
                "Item4": idTransformationPalletsDestination
            }],
            "joins": [{
                "Item1": "transformationsPalletsSource",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "transformationsPalletsSource",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }]
        };
        return json;
    }
}
